import Vue from 'vue';
import Vuex from 'vuex';
import Auth from './auth';
import Application from './application';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    Auth,
    Application,
  },
});

export default store;
